export const PricingToggle = ({ pcto, onChange, className = "mt-12 justify-center", testPrefix = "pricing" }) => {
  const onKey = (e) => {
    if (e.key === "ArrowRight") onChange(true);
    if (e.key === "ArrowLeft") onChange(false);
  };
  return (
    <div className={`flex flex-wrap items-center gap-4 sm:gap-5 ${className}`} data-testid={`${testPrefix}-toggle-group`}>
      <button
        type="button"
        onClick={() => onChange(false)}
        className={`min-h-[44px] px-1 text-sm sm:text-base font-semibold transition-colors duration-300 ${pcto ? "text-titanium" : "text-white"}`}
        data-testid={`${testPrefix}-label-standard`}
      >
        Prezzo Standard
      </button>
      <button
        type="button"
        role="switch"
        aria-checked={pcto}
        aria-label="Attiva lo sconto ospitalità Formazione Scuola-Lavoro (ex PCTO)"
        onClick={() => onChange(!pcto)}
        onKeyDown={onKey}
        className={`pricing-switch relative h-8 w-[60px] shrink-0 rounded-full border ${pcto ? "is-on" : ""}`}
        data-testid={`${testPrefix}-toggle`}
      >
        <span className="pricing-knob absolute top-1 left-1 h-[22px] w-[22px] rounded-full" />
      </button>
      <button
        type="button"
        onClick={() => onChange(true)}
        className={`min-h-[44px] px-1 text-sm sm:text-base font-semibold transition-[color,text-shadow] duration-300 ${pcto ? "text-cyan pcto-glow" : "text-titanium"}`}
        data-testid={`${testPrefix}-label-pcto`}
      >
        Sconto Ospitalità FSL (ex PCTO)
      </button>
    </div>
  );
};
